import React, { useEffect, useState, useRef } from "react";
import { CustomMarkerPreview } from "..";
import { useSelector } from "react-redux";
import { MarkerActions } from "../../_actions";
import { MarkerSearchResults } from ".";
import { DEFAULT_MARKER_IMAGE } from "../../_helpers";
import { useClickOutside } from "../../_hooks";
import { useFormContext, Controller } from "react-hook-form";
import { AnchorAlignmentButtons } from "./";
import { Icon, NumberPicker } from "../";

const tooltipIcon = "fas fa-info-circle fa-fw";

export function ImageMarkerPicker({
  onMarkerTypeSelect,
  color,
  value,
  onChange,
  contextPrefix = "",
  showAnchor = true,
  onAnchorChange,
  tooltipID,
  filter = null,
  templateOverrides,
}) {
  const [showAnchorButtons, setShowAnchorButtons] = useState(false);
  const [searchStr, setSearchStr] = useState(
    value && value.name ? value.name : ""
  );
  const [markerTypes, setMarkerTypes] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [selectedMarker, setSelectedMarker] = useState(value || null);
  const [isResultsVisible, setResultsVisible] = useState(false);
  const { items: markerImages } = useSelector((state) => state.markerTypes);

  // const dispatch = useDispatch();
  const searchRef = useRef();
  const inputRef = useRef();
  const handleSearchChange = (ev) => setSearchStr(ev.currentTarget.value);

  const { control, setValue, getValues } = useFormContext();

  const prefixKey = (key) => {
    return contextPrefix ? `${contextPrefix}.${key}` : key;
  };

  const handleTypeSelect = (markerType) => {
    // console.log("MarkerType", markerType);
    if (onMarkerTypeSelect) onMarkerTypeSelect(markerType);
    else setSelectedMarker(markerType);

    if (markerType && markerType.width) {
      setValue(prefixKey("width"), markerType.width);
    }

    if (markerType && markerType.height) {
      setValue(prefixKey("height"), markerType.height);
    }

    setResultsVisible(false);
    setSearchStr(markerType.name);
  };

  useEffect(() => {
    //... get markerTypes and store in list
    // dispatch(MarkerActions.getMarkerTypes()).then((data) => {
    //   setMarkerTypes([...data, DEFAULT_MARKER_IMAGE]);
    //   setSearchResults([...data, DEFAULT_MARKER_IMAGE]);
    // });
    console.log(markerImages.length);
    setSearchResults([...markerImages, DEFAULT_MARKER_IMAGE]);
    setMarkerTypes([...markerImages, DEFAULT_MARKER_IMAGE]);
  }, []);

  useEffect(() => {
    const query = searchStr.toLocaleLowerCase();
    if (query.length < 3) {
      setSearchResults([...markerImages, DEFAULT_MARKER_IMAGE]);
      // setResultsVisible(false);
      return;
    }

    //... filter results
    if (Array.isArray(markerTypes)) {
      let filteredResults = markerTypes
        .filter((markerType) => {
          //Check Name
          if (
            markerType.name &&
            markerType.name.toLocaleLowerCase().includes(query)
          ) {
            return true;
          }

          //Check tags
          if (markerType.tags && markerType.tags.length > 0) {
            return markerType.tags.includes(query);
          }

          //Check IDs
          if (
            markerType._id.toLocaleLowerCase() === query ||
            markerType.waID.toLocaleLowerCase() === query
          ) {
            return true;
          }
          return false;
        })
        .sort((a, b) => {
          const markerTypeA = a.name.toLocaleLowerCase();
          const markerTypeB = b.name.toLocaleLowerCase();
          return markerTypeA < markerTypeB
            ? -1
            : markerTypeA > markerTypeB
            ? 1
            : 0;
        });

      const defaultOptionOriginalIndex = filteredResults.findIndex(
        (r) => r.name === "Default Marker" && r.waID === ""
      );

      if (defaultOptionOriginalIndex >= 0) {
        filteredResults = [
          DEFAULT_MARKER_IMAGE,
          ...filteredResults.slice(0, defaultOptionOriginalIndex),
          ...filteredResults.slice(defaultOptionOriginalIndex + 1),
        ];
      }
      if (inputRef && inputRef.current === document.activeElement) {
        setResultsVisible(true);
      }
      setSearchResults(filteredResults);
    }
  }, [searchStr]);

  useEffect(() => {
    if (onChange) onChange(selectedMarker);
  }, [selectedMarker]);

  const handleClickOutside = () => {
    setResultsVisible(false);
  };

  const maxImageSize = {
    width:
      templateOverrides && templateOverrides.pinImg
        ? templateOverrides.pinImg.width
        : 40,
    height:
      templateOverrides && templateOverrides.pinImg
        ? templateOverrides.pinImg.height
        : 40,
  };

  const toggleResults = (mode) => {
    if (mode !== undefined) {
      setResultsVisible(mode);
    } else {
      setResultsVisible((m) => !m);
    }
  };

  const handleClearSearch = () => {
    setSearchStr("");
  };

  const alignAnchor = (pos) => {
    let newPos = {
      x: 0,
      y: 0,
    };
    switch (pos.toLowerCase()) {
      case "bottomcenter": {
        newPos.y = (
          parseFloat(getValues("templateOverrides.height")) * 1
        ).toFixed(2);
        newPos.x = (
          parseFloat(getValues("templateOverrides.width")) / 2
        ).toFixed(2);
        break;
      }
      case "bottomleft": {
        newPos.y = (
          parseFloat(getValues("templateOverrides.height")) * 1
        ).toFixed(2);
        newPos.x = 0;
        break;
      }
      case "bottomright": {
        newPos.y = (
          parseFloat(getValues("templateOverrides.height")) * 1
        ).toFixed(2);
        newPos.x = parseFloat(getValues("templateOverrides.width")).toFixed(2);
        break;
      }
      case "centercenter": {
        newPos.y = (
          parseFloat(getValues("templateOverrides.height")) / 2
        ).toFixed(2);
        newPos.x = (
          parseFloat(getValues("templateOverrides.width")) / 2
        ).toFixed(2);
        break;
      }
      case "centerleft": {
        newPos.y = (
          parseFloat(getValues("templateOverrides.height")) / 2
        ).toFixed(2);
        newPos.x = 0;
        break;
      }
      case "centerright": {
        newPos.y = (
          parseFloat(getValues("templateOverrides.height")) / 2
        ).toFixed(2);
        newPos.x = parseFloat(getValues("templateOverrides.width")).toFixed(2);
        break;
      }
      case "topcenter": {
        newPos.y = 0;
        newPos.x = newPos.x = (
          parseFloat(getValues("templateOverrides.width")) / 2
        ).toFixed(2);
        break;
      }
      case "topleft": {
        newPos.y = 0;
        newPos.x = 0;
        break;
      }
      case "topright": {
        newPos.y = 0;
        newPos.x = parseFloat(getValues("templateOverrides.width")).toFixed(2);
        break;
      }
    }

    setValue("templateOverrides.anchorX", parseFloat(newPos.x));
    setValue("templateOverrides.anchorY", parseFloat(newPos.y));
  };
  useClickOutside(searchRef, handleClickOutside);

  return (
    <div className="chronos-marker-template-image-picker-component">
      <div className="chronos-marker-template-image-search" ref={searchRef}>
        <div className="chronos-list-search">
          <input
            type="text"
            value={searchStr}
            ref={inputRef}
            onChange={handleSearchChange}
            onClick={() => toggleResults()}
            placeholder="Search Markers"
            className="form-control chronos-search-input chronos-input"
            // onFocus={() => setResultsVisible(true)}
          />
          {searchStr && searchStr.length && (
            <Icon
              icon="fas fa-times fa-fw"
              style={{ marginRight: "0.25rem", fontSize: "0.75rem" }}
              onClick={handleClearSearch}
            />
          )}
          <Icon icon="fas fa-search fa-fw" />
        </div>

        {isResultsVisible && (
          <MarkerSearchResults
            results={searchResults}
            onSelect={handleTypeSelect}
          />
        )}
      </div>
      <div className="icon-display">
        <CustomMarkerPreview
          isImageMode
          markerImage={selectedMarker}
          primaryColor={color}
          keyPrefix={contextPrefix}
          filter={filter}
        />
        {showAnchor && (
          <div className="chronos-custom-icon-anchor">
            <p className="chronos-section-title">
              Anchor Position&nbsp;
              <Icon
                icon={tooltipIcon}
                data-tip={`<div>
            This controls the spot on the image that indicates how
            the marker will be placed relative to the desired
            position. For 'pin' style images, the anchor should be
            halfway horizontally and at the bottom vertically. For
            round or square shaped images, the anchor should be
            positioned in the center both vertically and
            horizontally.
          </div>`}
                data-html={true}
                data-multiline={true}
                data-for={tooltipID}
              />
            </p>
            <AnchorAlignmentButtons handler={alignAnchor} />
            {/* <label
          onClick={() => setShowAnchorButtons(!showAnchorButtons)}
          className="chronos-form-title"
        >
          <span>
            Advanced&nbsp;
            <Icon
              icon={tooltipIcon}
              data-for={tooltipID}
              data-tip="If you need more granular control on the anchor's position, you can adjust it using these options."
            />
          </span>

          <Icon
            icon={
              showAnchorButtons
                ? 'far fa-chevron-up fa-fw'
                : 'far fa-chevron-down fa-fw'
            }
            style={{ marginLeft: '1rem' }}
          />
        </label> */}
            {showAnchorButtons && (
              <React.Fragment>
                <label
                  htmlFor="templateOverrides.anchorX"
                  className="chronos-form-title"
                >
                  Horizontal Position (X)
                </label>
                <Controller
                  control={control}
                  name="templateOverrides.anchorX"
                  render={({ value, onChange }) => (
                    <NumberPicker
                      value={value}
                      onChange={onChange}
                      min={0}
                      max={maxImageSize.width}
                    />
                  )}
                />
                <label
                  htmlFor="templateOverrides.anchorY"
                  className="chronos-form-title"
                >
                  Vertical Position (Y)
                </label>
                <Controller
                  control={control}
                  name="templateOverrides.anchorY"
                  render={({ value, onChange }) => (
                    <NumberPicker
                      value={value}
                      onChange={onChange}
                      min={0}
                      max={maxImageSize.height}
                    />
                  )}
                />
              </React.Fragment>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
